<template>
<w-sliding-popup type="setting" ref="slidingPopup" :title="fileChangeTitle" @close="close" width="550px">
  <el-form slot="content" :model="detectInfo" :rules="rules" label-position="top" :ref="formName">
    <el-row>
      <el-col :span="24">
        <el-form-item label="파일형태" :rules="[{ required: true, message: '파일형태를 선택하십시오.', trigger: 'blur' }]">
          <el-radio-group v-model="patternFlag" :disabled="isEdit">
            <el-radio label="N">고정형</el-radio>
            <el-radio label="Y">패턴형</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <!-- <el-row>
      <el-col :span="24">
        <el-form-item label="대상 파일(경로 포함하여 설정 필요)" prop="path" v-if="patternFlag==='N'">
          <el-input :disabled="isEdit" v-model="detectInfo.path" placeholder="파일 경로와 이름"></el-input>
        </el-form-item>
        <el-form-item label="대상 파일(경로 포함하여 설정 필요)" prop="beforePattern" v-if="patternFlag==='Y'">
          <el-input :disabled="isEdit" v-model="detectInfo.beforePattern" placeholder="패턴 앞"></el-input>
        </el-form-item>
        <el-form-item prop="pattern" v-if="patternFlag==='Y'">
          <el-input :disabled="isEdit" v-model="detectInfo.pattern" placeholder="패턴"></el-input>
        </el-form-item>
        <el-form-item prop="afterPattern" v-if="patternFlag==='Y'">
          <el-input :disabled="isEdit" v-model="detectInfo.afterPattern" placeholder="패턴 뒤"></el-input>
        </el-form-item>
      </el-col>
    </el-row> -->
    <el-row>
      <el-col :span="24">
        <el-form-item label="대상 파일(경로 포함하여 설정 필요)" prop="path" v-if="patternFlag==='N'">
          <el-input :disabled="isEdit" v-model="detectInfo.path" placeholder="파일 경로와 이름"></el-input>
        </el-form-item>
        <el-form-item label="대상 파일(경로 포함하여 설정 필요)" prop="beforePattern" v-if="patternFlag==='Y'">
          <el-input :disabled="isEdit" v-model="detectInfo.beforePattern" placeholder="패턴 앞"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="patternFlag==='Y'">
      <el-col :span="24">
        <el-form-item prop="pattern">
          <el-input :disabled="isEdit" v-model="detectInfo.pattern" placeholder="패턴"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="patternFlag==='Y'">
      <el-col :span="24">
        <el-form-item prop="afterPattern" v-if="patternFlag==='Y'">
          <el-input :disabled="isEdit" v-model="detectInfo.afterPattern" placeholder="패턴 뒤"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <hr class="mr-t25"/>
    <el-row>
      <el-col :span="24">
        <el-form-item label="감시 주기 설정(초)" prop="detectFileSize">
          <el-input-number v-model="detectInfo.detectFileSize" controls-position="right" :min="0"></el-input-number>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="text-small">
      * 감시 주기 설정(초) 이란?<br>
      감지되는 파일의 변경여부를 체크하는 주기를 설정합니다.<br>
      지정된 파일의 변경주기가 감시 주기 설정 값보다 작을 경우 이력에 저장됩니다.<br>
    </div>
    <hr class="mr-t25"/>
    <el-form-item prop="detectTimeApply">
      <div class="title-bar" style="margin-top:5px">
        <div class="title-h5 mr-r10">감시 구간 설정</div>
        <el-switch v-model="detectInfo.detectTimeApply" active-value="Y" inactive-value="N"></el-switch>
      </div>
    </el-form-item>
    <el-row>
      <el-col :span="12">
        <el-form-item prop="detectStarttime">
          <w-time-selection-component :disabled="detectInfo.detectTimeApply === 'N'" class="title-popup-s" ref="detectStarttime" title="구간 시작 시간" :width="90"
          :execute-hour="detectInfo.startHour" :execute-minute="detectInfo.startMinute" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item prop="detectEndtime">
          <w-time-selection-component :disabled="detectInfo.detectTimeApply === 'N'" class="title-popup-s" ref="detectEndtime" title="구간 종료 시간" :width="90"
          :execute-hour="detectInfo.endHour" :execute-minute="detectInfo.endMinute" />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <el-row slot="footer" type="flex" justify="center">
    <el-button size="large" class="mr-r4" type="solid" @click="saveChangeFileDetect">저장</el-button>
    <el-button size="large" @click="closePopup">취소</el-button>
  </el-row>
</w-sliding-popup>
</template>

<script>
import { clone, isUndefined, isNil, isEmpty } from 'lodash';
import msgUtil from '@/utils/message';
import { pad } from '@/utils/string';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import WTimeSelectionComponent from '@/views/settings/components/TimeSelectionComponent';

const DEFAULT_DETECT = {
  path: null,
  detectFileSize: 0,
  afterPattern: null,
  beforePattern: null,
  pattern: null,
  detectTimeApply: 'N',
};

export default {
  name: 'WFileChangePopup',
  components: {
    WTimeSelectionComponent,
  },
  props: {
    popupType: String,
    editRow: Object,
    selectPhysicalNode: Object,
  },
  data() {
    return {
      isEdit: false,
      formName: 'detectInfoForm',
      fileChangeTitle: '감시 파일 추가',
      patternFlag: null,
      detectInfo: {
        path: null,
        detectFileSize: 0,
        afterPattern: null,
        beforePattern: null,
        pattern: null,
        detectTimeApply: 'N',
      },
      rules: {
        path: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validatePath,
          },
        ],
        afterPattern: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validateNull,
            message: '필수 정보입니다.',
          },
        ],
        beforePattern: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validateNull,
            message: '필수 정보입니다.',
          },
        ],
        pattern: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validateNull,
            message: '필수 정보입니다.',
          },
        ],
        detectEndtime: [
          {
            validator: this.validateTime,
          },
        ],
      },
    };
  },
  watch: {
    editRow: {
      handler(row) {
        if (isEmpty(row)) {
          this.detectInfo = clone(DEFAULT_DETECT);
        } else {
          this.detectInfo = clone(row);
          const detectStarttime = this.detectInfo.detectStarttime;
          const detectEndtime = this.detectInfo.detectEndtime;
          this.$nextTick(() => {
            if (!isNil(detectStarttime)) {
              const timeArr = this.detectInfo.detectStarttime.split(':');
              const hour = timeArr[0];
              const minute = timeArr[1];
              this.$refs.detectStarttime.hour = parseInt(hour, 10);
              this.$refs.detectStarttime.minute = parseInt(minute, 10);
            }
            if (!isNil(detectEndtime)) {
              const timeArr = this.detectInfo.detectEndtime.split(':');
              const hour = timeArr[0];
              const minute = timeArr[1];
              this.$refs.detectEndtime.hour = parseInt(hour, 10);
              this.$refs.detectEndtime.minute = parseInt(minute, 10);
            }
          });
        }

        if (this.popupType === 'ADD') {
          this.isEdit = false;
          this.patternFlag = 'N';
          this.fileChangeTitle = `[${this.selectPhysicalNode.label}] 감시 파일 추가`;
        } else {
          this.isEdit = true;
          this.patternFlag = row.patternFlag;
          this.fileChangeTitle = `[${this.selectPhysicalNode.label}] 감시 파일 정보 수정`;
        }
      },
      deep: true,
    },
    'detectInfo.detectTimeApply': {
      handler(flag) {
        if (flag === 'N') {
          this.$refs[this.formName].clearValidate('detectEndtime');
        }
      },
    },
  },
  methods: {
    pad,
    close() {
      this.$refs.detectStarttime.init();
      this.$refs.detectEndtime.init();
      this.$refs[this.formName].resetFields();
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    validateNull(rule, value, callback) {
      if (isUndefined(value) || value === '' || isNil(value)) {
        callback(new Error());
      } else {
        callback();
      }
    },
    validatePath(rule, value, callback) {
      if (isUndefined(value) || value === '' || isNil(value)) {
        callback(new Error('필수 정보입니다.'));
      } else if (this.popupType === 'ADD') {
        const params = {
          serverId: this.selectPhysicalNode.serverId,
          path: this.detectInfo.path,
          isDirectory: 'N',
        };
        ServerSettingAPI.checkExistDetectFile(params).then((response) => {
          if (response.data.success) {
            if (response.data.data) {
              callback(new Error('이미 존재하는 감시 디렉토리입니다.'));
            } else {
              callback();
            }
          } else {
            callback(new Error('중복 여부를 확인하지 못하였습니다.'));
          }
        }).catch(() => {
          callback(new Error('중복 여부를 확인하지 못하였습니다.'));
        });
      } else {
        callback();
      }
    },
    validateTime(rule, value, callback) {
      if (this.detectInfo.detectTimeApply === 'N') {
        callback();
      } else {
        const detectStarttime = this.$refs.detectStarttime.getSelectionTime();
        const detectEndtime = this.$refs.detectEndtime.getSelectionTime();
        if (detectStarttime.hour === detectEndtime.hour && detectStarttime.minute === detectEndtime.minute) {
          callback(new Error('종료시간은 시작시간과 같을 수 없습니다.'));
        } else {
          callback();
        }
      }
    },
    saveChangeFileDetect() {
      const me = this;
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          const target = '감시 디렉토리';
          const detectStarttime = this.$refs.detectStarttime.getSelectionTime();
          const detectEndtime = this.$refs.detectEndtime.getSelectionTime();
          if (this.popupType === 'ADD') {
            const saveParams = clone(this.detectInfo);
            if (this.patternFlag === 'Y') {
              saveParams.path = this.getPathName();
            }
            saveParams.isDirectory = 'N';
            saveParams.patternFlag = this.patternFlag;
            saveParams.serverId = this.selectPhysicalNode.serverId;
            saveParams.detectStarttime = `${pad(detectStarttime.hour, 2)}:${pad(detectStarttime.minute, 2)}`;
            saveParams.detectEndtime = `${pad(detectEndtime.hour, 2)}:${pad(detectEndtime.minute, 2)}`;

            const action = msgUtil.action.ADD;
            ServerSettingAPI.insertBulkFileDetectDir(saveParams).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('reload-data');
                this.closePopup();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          } else {
            const saveParams = clone(this.detectInfo);
            saveParams.serverId = this.selectPhysicalNode.serverId;
            saveParams.fileID = me.editRow.fileId;
            saveParams.pathHash = me.editRow.pathHash;

            saveParams.detectStarttime = `${pad(detectStarttime.hour, 2)}:${pad(detectStarttime.minute, 2)}`;
            saveParams.detectEndtime = `${pad(detectEndtime.hour, 2)}:${pad(detectEndtime.minute, 2)}`;
            const action = msgUtil.action.SAVE;
            ServerSettingAPI.updateBulkFileDetectDir(saveParams).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('reload-data');
                this.closePopup();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          }
        }
      });
    },
    getPathName() {
      const changeInfo = clone(this.detectInfo);
      return changeInfo.beforePattern + changeInfo.pattern + changeInfo.afterPattern;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/FileDetectSettings/FileChangeDetectView/popup/FileChangePopup.vue